__turbopack_context__.v({
  "style": "GithubrepoLenke-module__Cc2vCa__style",
});
